/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import "./layout.css";
import { Link } from "gatsby";

const Layout = ({ children, Onabout }) => {
  Onabout = Onabout || false;
  return (
    <>
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
      >
        <main>{children}</main>
        <footer
          style={{
            marginTop: `2rem`,
            paddingBottom: `2rem`,
          }}
        >
          © {new Date().getFullYear()}, Built with
          {` `}
          <a href="https://www.gatsbyjs.com" target="_blank" rel="noopener">
            Gatsby
          </a>
          {`, `}
          <a href="https://thecatapi.com" target="_blank" rel="noopener">
            TheCatAPI
          </a>
          {`, `}
          <a href="https://kanye.rest" target="_blank" rel="noopener">
            Kanye.rest
          </a>
        </footer>

        <Link to={Onabout ? "/" : "/about"}>{Onabout ? "Home" : "About"}</Link>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
